module.exports = __webpack_public_path__ + "static/media/teacher_view_search_video.c0de727c.mov";